The HTML content of the description.
